import { useAtomValue } from 'jotai'
import { memo } from 'react'
import { navIndicatorAtom } from './atoms'
import { styled } from '@mui/material'

const Indicator = styled('div')`
  height: 3px;
  background-color: rgba(160, 238, 9, 1);
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  transition: all 0.3s ease;

  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
`

export const NavIndicator = memo(() => {
  const { left, width } = useAtomValue(navIndicatorAtom)
  return (
    <Indicator
      sx={{
        left,
        width,
      }}
    ></Indicator>
  )
})
